import axios from 'axios'
import qs from 'Qs'
import router from './router/index';
import store from './store';

// var host = 'https://api.yun72.com';
var host = 'https://api.yxj.pwbot.cn';

function closeLoad(loading) {
  if (loading) {
    setTimeout(loading, 500)
  }
}

export default {
  host: host,
  post(url, data = new Object) {
    return new Promise((resolve, reject) => {
      var userInfo = localStorage.getItem("userInfo");
      if (userInfo) {
        data['token'] = JSON.parse(userInfo).token;
      }else{
        if(url!='/developers/login'){
          router.push('/login');
          return
        }
      }
      // console.log(url,'url');
      axios.post(
        host + url,
        // qs.stringify(data,{ arrayFormat: 'brackets' })
        qs.stringify(data)
      )
        .then(function (response) {
          var res = response.data;
          if (res.code == 999) {
            store.commit('delUserInfo');
            router.push('/login');
          } else {
            resolve(res);
          }
        })
        .catch(function (error) {
        });
    })
  },
  get(url, data = new Object) {
    return new Promise((resolve, reject) => {
      var userInfo = localStorage.getItem("userInfo");
      if (userInfo) {
        data['token'] = JSON.parse(userInfo).token;
      }else{
        router.push('/login');
        return;
      }

      // console.log(userInfo,'data');

      axios.get(host + url, { params: data })
        .then(function (response) {
          var res = response.data;
          if (res.code == 999) {
            store.commit('delUserInfo');
            router.push('/login');
          } else {
            resolve(res);
          }
        })
        .catch(function (error) {
        });
    })
  },
  upImgs(files, cb) {
    var formdata = new FormData()
    formdata.append("images", files)
    axios.post(host + '/developers/uploads', formdata)
      .then(response => {
        cb(response.data)
      }, err => {
        Message({ message: '系统发生错误～', 'type': 'warning' });
        reject(err)
      })
  }
} 


// WEBPACK FOOTER //
// ./src/api.js